import React from "react";

interface IProps {
  isSelected: boolean;
  displayBorders?: boolean;
  onClick?: () => void;
  onDoubleClick: () => void;
  image: string;
  title: string;
  description?: string;
  videoBannerUrl?: string;
  badge?: string;
}

const TrackTile: React.FC<IProps> = ({ isSelected, onClick, image, title, displayBorders, onDoubleClick, description, videoBannerUrl, badge }) => {
  const containerClass = `hover:tw-cursor-pointer tw-flex tw-flex-col tw-justify-center tw-items-center lg:tw-block lg:tw-mx-auto`;

  const tileStyle =
    isSelected || displayBorders
      ? {
          padding: "4px",
          background: title.toLowerCase().includes("battle") 
            ? "linear-gradient(180deg, #FAC618 0%, #EA581A 100%)" 
            : "linear-gradient(282.87deg,#f908ff 6.14%,#d32efe 14.09%,#37ccfb 91.49%,#05fffa 103.26%)",
        }
      : {};

  const titleText = title.split("_").join(" ").toLowerCase();

  return (
    <div className={containerClass}>
      <div className="tw-h-[165px] tw-w-[280px] lg:tw-h-[380px] tw-rounded-[25px] tw-overflow-hidden tw-relative" style={tileStyle} onClick={onClick} onDoubleClick={onDoubleClick}>
        {videoBannerUrl ? (
          <div className="tw-h-full tw-w-full tw-rounded-[22px] tw-relative">
            <video
              className="tw-h-full tw-w-full tw-rounded-[22px] tw-object-cover"
              src={videoBannerUrl}
              autoPlay
              loop
              muted
              playsInline
              controls={false}
              style={{ pointerEvents: "none" }}
            />
            <div className="tw-absolute tw-inset-0" />
            <div className="tw-absolute tw-inset-0 tw-pointer-events-none" />
            {badge && (
              <div
                className="tw-absolute tw-top-1 tw-right-1 tw-text-white tw-text-[20px] tw-font-bold tw-rounded-[33px] tw-px-[15px] tw-py-[5px]"
                style={{ background: "linear-gradient(282.87deg,#f908ff 6.14%,#d32efe 14.09%,#37ccfb 91.49%,#05fffa 103.26%)" }}
              >
                {badge}
              </div>
            )}
            <div
              className={`tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full tw-absolute tw-top-0 tw-left-0 tw-rounded-[25px] ${
                isSelected ? "tw-bg-opacity-0" : "tw-bg-opacity-50"
              }`}
            >
              {titleText && titleText.includes("battle") ? (
                <span className="tw-text-white tw-font-bold hover:tw-cursor-text tw-text-[24px]">BattleKart</span>
              ) : (
                <span className="tw-text-white tw-font-bold hover:tw-cursor-text tw-text-[24px] tw-capitalize">{titleText}</span>
              )}
            </div>
            {description && (
              <p className="tw-text-white tw-absolute tw-bottom-[10px] tw-left-0 tw-right-0 tw-bg-[#37415180] tw-mx-[10px] tw-p-[10px] tw-text-center tw-text-[10px] tw-rounded-[22px] tw-font-[600] lg:tw-hidden">
                {description}
              </p>
            )}
          </div>
        ) : (
          <div
            className="tw-bg-cover tw-bg-center tw-h-full tw-w-full tw-rounded-[22px]"
            style={{ backgroundImage: `url("https://hyperkarting-product-component.vercel.app${image}")` }}
          >
            <div
              className={`tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full tw-relative tw-bg-indigo-900 tw-rounded-[25px] ${
                isSelected ? "tw-bg-opacity-0" : "tw-bg-opacity-50"
              }`}
            >
              {badge && (
                <div
                  className="tw-absolute tw-top-1 tw-right-1 tw-text-white tw-text-[14px] tw-font-bold tw-rounded-[22px] tw-px-[10px] tw-py-[5px]"
                  style={{ background: "linear-gradient(282.87deg,#f908ff 6.14%,#d32efe 14.09%,#37ccfb 91.49%,#05fffa 103.26%)" }}
                >
                  {badge}
                </div>
              )}
              <span className="tw-text-white tw-font-bold hover:tw-cursor-text tw-text-[24px] tw-capitalize">{titleText}</span>
            </div>
          </div>
        )}
      </div>
      {description && <p className="tw-text-white tw-w-[280px] tw-text-center tw-pt-[10px] tw-hidden lg:tw-block">{description}</p>}
    </div>
  );
};

export default TrackTile;
